export function badgeConfig({ colors }) {
    return {
        colorVariant: {
            warning: colors.text.invertedColor
        }
    };
}
